import React, { useState } from 'react';
import { StyledInput, ErrorText } from './Styles';
import InputWrapper from './InputWrapper';

interface TextInputProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEmailInput?: boolean;
  required?: boolean;
  error?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  isEmailInput = false,
  required = false,
  error,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <InputWrapper
      id={id}
      label={label}
      required={required}
      value={value}
      isFocused={isFocused}
    >
      <StyledInput
        id={id}
        name={name}
        type={isEmailInput ? 'email' : 'text'}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        required={required}
        aria-required={required}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        autoComplete="on"
      />
    </InputWrapper>
  );
};

export default TextInput;
